import type {
  ModalPipeline,
  ModalRequest,
  ModalResponse,
} from './adminTypes';
import { createFetchCache } from './createFetchCache';

export const INITIAL_MODAL_FREQUENCY_HZ = 40;

const cache = createFetchCache<string, ModalResponse>({
  sig: (signature) => signature,
});

export function modalSig(
  request: ModalRequest,
  pipeline: ModalPipeline | undefined,
): string {
  return JSON.stringify({ request, pipeline: pipeline ?? null });
}

export function getCachedModal(signature: string): ModalResponse | null {
  return cache.getCached(signature) ?? null;
}

export function fetchModal(
  signature: string,
  fetcher: () => Promise<ModalResponse>,
): Promise<ModalResponse> {
  return cache.fetch(signature, fetcher);
}

export function primeCachedModal(signature: string, response: ModalResponse): void {
  cache.prime(signature, response);
}

export function clearModalCache(): void {
  cache.clear();
}
